var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentName)?_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.componentParams,false)):_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }